import { ChainId } from '@pancakeswap/sdk'
import { Address } from 'viem'

import { SupportedChainId } from './supportedChains'

export type ContractAddresses<T extends ChainId = SupportedChainId> = {
  [chainId in T]: Address
}

export const ICAKE = {
  [ChainId.MANTLE]: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
  [ChainId.MANTLE_TESTNET]: '0x',
} as const satisfies ContractAddresses<SupportedChainId>

export const CAKE_VAULT = {
  [ChainId.MANTLE]: '0x45c54210128a065de780C4B0Df3d16664f7f859e',
  [ChainId.MANTLE_TESTNET]: '0x683433ba14e8F26774D43D3E90DA6Dd7a22044Fe',
} as const satisfies ContractAddresses<SupportedChainId>

export const CAKE_FLEXIBLE_SIDE_VAULT = {
  [ChainId.MANTLE]: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
  [ChainId.MANTLE_TESTNET]: '0x',
} as const satisfies ContractAddresses<SupportedChainId>
